export class DisplayData {

  constructor(){
    this.displayData1 = this.displayData2 = this.displayData3 = this.displayData4 = this.displayData5 = "";
  }

    displayData1: string;
    displayData2: string;
    displayData3: string;
    displayData4: string;
    displayData5: string;
    displayData6: string = '';
    displayData6_Style:any;
    showDefaultMessage:boolean = true;

    disableDefaultMessage = () => this.showDefaultMessage = false;
    toString = () => this.displayData1 + " " + this.displayData2 + " " + this.displayData3 + " " + this.displayData4 + " " + this.displayData5 + " " + this.displayData6 ;
}
